import React,{useEffect} from 'react';

const Header = () => {
  const openAside = () => {
    document.getElementById('mySidenav')?.classList.add('active');
    document.body.style.overflow = 'hidden'; // Optional: prevent background scroll
  };

  // Sidebar close
  const closeAside = () => {
    document.getElementById('mySidenav')?.classList.remove('active');
    document.body.style.overflow = 'auto';
  };

  // Optional: close sidebar on link click (for single page experience)
  useEffect(() => {
    const links = document.querySelectorAll('#mySidenav a');
    links.forEach((link) => {
      link.addEventListener('click', closeAside);
    });

    return () => {
      links.forEach((link) => {
        link.removeEventListener('click', closeAside);
      });
    };
  }, []);
  return (
   
      <header>
      <nav
        className="navbar navbar-expand-lg w-100  py-3 bg-transparent"
        style={{ zIndex: 999, position: "fixed", top: 0, left: 0 }}
        data-aos="fade-down"
        id="mainNavbar"
      >

      <div className="container-fluid">
        {/* site logo */}
        <a className="nav-logo p-0" href="/">
          <figure>
            <img src="/assets/images/DNET-logo.png" alt="logo" />
          </figure>
        </a>
        {/* navigation button  */}
        <div className="d-flex gap-md-3">
            <button className="open-aside" type="button" onClick={openAside}>
              <i className="fa-solid fa-bars" />
            </button>
          {/* navigation bar manu  */}
          <div className="d-flex justify-content-end gap-xl-4 gap-lg-3">
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav d-flex justify-content-center align-items-center gap-lg-3 gap-md-2 gap-sm-2 gap-2 mb-2 mb-lg-0">
                <li className="nav-item">
                  <a className="nav-link " style={{color: "#ffff"}} href="/">
                    Home
                  </a>
                </li>
                  {/* <li className="nav-item">
                    <a className="nav-link"  style={{color: "#ffff"}} href="/Courses">
                      Classes
                    </a>
                  </li> */}
                <li className="nav-item">
                  <a className="nav-link"  style={{color: "#ffff"}} href="/Programs">
                    Programs
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link"  style={{color: "#ffff"}} href="/AboutUs">
                    About
                  </a>
                </li> 
                <li className="nav-item">
                  <a className="nav-link" style={{color: "#ffff"}} href="/Academics">
                  Academics
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" style={{color: "#ffff"}} href="/Admissions">
                  Admissions
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" style={{color: "#ffff"}} href="/Blog">
                  Blogs
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" style={{color: "#ffff"}} href="/ContactUs">
                    Contact Us
                  </a>
                </li>
                <li className="dropdown">
                  <a
                    className="nav-link d-flex align-item-center gap-1"
                    href="#"  style={{color: "#ffff"}}
                  >
                    Pages
                    <i className="fa-sharp fa-solid fa-sort-down" />
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <a className="dropdown-item" href="/Campus">
                        Campus
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="/Parentcorner">
                       Parent Corner
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="/Archivements">
                      Archivements
                      </a>
                    </li>
                    {/* <li>
                      <a className="dropdown-item" href="FAQs.html">
                        FAQs
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="Team.html">
                        Team
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="Moments.html">
                        Moments
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="Error.html">
                        404
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="ComingSoon.html">
                        Coming Soon
                      </a>
                    </li> */}
                  </ul>
                </li>
              </ul>
            </div>
            <div>
              <a href="#" className="hover1 btn-sm" id="getStartedAnchor">
                Get Started
              </a>
            </div>
          </div>
        </div>
      </div>
    </nav>
    {/*===== aside navigation slidebar =====*/}
    <aside>
    <div id="mySidenav" className="right-sidbar">
          <div className="side-nav-logo d-flex justify-content-between align-items-center ps-2 pe-1 nav-logo">
            <figure className="navbar-brand">
              <a href="/">
                <img src="/assets/images/DNET-logo.png" alt="Logo" />
              </a>
            </figure>
            <button className="fa-solid fa-xmark" onClick={closeAside} />
          </div>
        <ul className="pt-4">
          <li className="nav-item active">
            <a aria-current="page" href="/">
              Home
            </a>
          </li>
          <li className="nav-item">
            <a href="/Programs">Programs</a>
          </li>
          <li className="nav-item">
            <a href="/AboutUs">About</a>
          </li>
          <li className="nav-item">
            <a href="/Academics">Academics</a>
          </li>
           <li className="nav-item">
            <a href="/Admissions">Admissions</a>
          </li>
          <li className="nav-item">
            <a href="/Blog">Blog</a>
          </li>
          <li className="nav-item">
            <a href="/ContactUs">ContactUs</a>
          </li>
          <li className="nav-item">
            <div
              className="d-flex align-items-center justify-content-between"
              id="slid-btn"
            >
              <button className="a-slid page-btn">Pages</button>
              <i className="fa-solid fa-caret-down pe-2" />
            </div>
            <ul id="slid-drop">
              <li>
                <a href="/Campus">Campus</a>
              </li>
              <li>
                <a href="/Parentcorner">Parent Corner</a>
              </li>
              <li>
                <a href="/Archivements">Archivements</a>
              </li>
              {/* <li>
                <a href="Testimonial.html">Testimonial</a>
              </li> */}
              {/* <li>
                <a href="FAQs.html">FAQs</a>
              </li>
              <li>
                <a href="Team.html">Team</a>
              </li>
              <li>
                <a href="Moments.html">Moments</a>
              </li>
              <li>
                <a href="Error.html">404</a>
              </li>
              <li>
                <a href="ComingSoon.html">Coming Soon</a>
              </li> */}
            </ul>
          </li>
        </ul>
      </div>
    </aside>
  </header>
    
  )
}

export default Header
